import React, { FC, ReactElement } from 'react';

import { useMediaQuery } from '@material-ui/core';

import moment from 'moment';

import styles from './styles.module.scss';

import { InfoCircle, Loader, TableDataNotFound } from 'components/index';
import { ProposalsBarChart } from './components';

import { DATA_NOT_FOUND } from 'constants/dataNotFound';

import { useAppSelector } from 'store';
import { VotesBarChart } from './components/VotesBarChart';
import { TRENDS_TAB, TRENDS_TAB_DESCRIPTIONS } from '../../../../../../../../constants';

export const ProposalsVotesGraph: FC = (): ReactElement => {
    const {
        organizationActivityData: { monthlyActivity },
        activityDataLoading,
    } = useAppSelector(({ organization }) => organization);
    const isMobile = useMediaQuery('(max-width: 575.98px)');
    const dataToRender = monthlyActivity;
    return (
        <div className={styles.graphWrapper}>
            <div className={styles.proposalsGraphCard}>
                <div className={styles.header}>
                    <span className={styles.title}>Proposals</span>
                    <InfoCircle
                        tooltipText={TRENDS_TAB_DESCRIPTIONS[TRENDS_TAB.PROPOSALS]}
                        className={styles.infoIcon}
                    />
                </div>

                <div className={styles.proposalsGraphCardWrapper}>
                    {activityDataLoading && <Loader className={styles.loaderBox} size={50} />}

                    <div className={styles.wrapper}>
                        <div className={styles.graphInfoContent}>
                            <span className={styles.date}>
                                {monthlyActivity?.length
                                    ? moment(monthlyActivity?.[0].createdAt).format('MMMM YYYY')
                                    : DATA_NOT_FOUND}
                                {' - '}
                                {monthlyActivity?.length
                                    ? moment(monthlyActivity?.[monthlyActivity.length - 1].createdAt).format(
                                          'MMMM YYYY',
                                      )
                                    : DATA_NOT_FOUND}
                            </span>
                            {!isMobile && (
                                <div className={styles.barColoringInfo}>
                                    <span className={styles.proposalsColoring}>proposals</span>
                                </div>
                            )}
                        </div>
                        {!activityDataLoading && dataToRender.length === 0 && (
                            <TableDataNotFound forGraph removeMargins />
                        )}
                        <ProposalsBarChart data={dataToRender} />
                    </div>
                </div>
            </div>

            <div className={styles.proposalsGraphCard}>
                <div className={styles.header}>
                    <span className={styles.title}>Votes</span>
                    <InfoCircle tooltipText={TRENDS_TAB_DESCRIPTIONS[TRENDS_TAB.VOTES]} className={styles.infoIcon} />
                </div>

                <div className={styles.proposalsGraphCardWrapper}>
                    {activityDataLoading && <Loader className={styles.loaderBox} size={50} />}

                    <div className={styles.wrapper}>
                        <div className={styles.graphInfoContent}>
                            <span className={styles.date}>
                                {monthlyActivity?.length
                                    ? moment(monthlyActivity?.[0].createdAt).format('MMMM YYYY')
                                    : DATA_NOT_FOUND}
                                {' - '}
                                {monthlyActivity?.length
                                    ? moment(monthlyActivity?.[monthlyActivity.length - 1].createdAt).format(
                                          'MMMM YYYY',
                                      )
                                    : DATA_NOT_FOUND}
                            </span>
                            {!isMobile && (
                                <div className={styles.barColoringInfo}>
                                    <span className={styles.votesColoring}>votes</span>
                                </div>
                            )}
                        </div>
                        {!activityDataLoading && dataToRender.length === 0 && (
                            <TableDataNotFound forGraph removeMargins />
                        )}
                        <VotesBarChart data={dataToRender} />
                    </div>
                </div>
            </div>
        </div>
    );
};
